import type { FC } from 'react'
import React, { memo } from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { Button, Image } from '@/components/ui'
import { formatHighlightedText } from '@/components/ui/HighlightedText'
import { useWebpExtension } from '@/utils/hooks/image'
import { messages } from './messages'
import './styles.scss'

const AgentBannerComponent: FC = () => {
  const imageExtension = useWebpExtension()

  return (
    <CommonLink url="/financingOffer/agent">
      <div className="agentBanner">
        <div className="agentBanner__image">
          <Image src={`financing/agentBanner.${imageExtension}`} isInStatic />
        </div>
        <div className="agentBanner__content">
          <div className="agentBanner__info">
            <h3 className="agentBanner__infoTitle">{formatHighlightedText(messages.title)}</h3>
            <p className="agentBanner__infoText">{messages.text}</p>
          </div>
          <div className="agentBanner__button">
            <Button modifiers={['green', 'full-width-mobile']}>{messages.button}</Button>
          </div>
        </div>
      </div>
    </CommonLink>
  )
}

export const AgentBanner = memo(AgentBannerComponent)
